import { useState } from "react";
import { Review } from "src/graphql/generated/graphql";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { ReviewCard } from "../../../../components/ReviewCard";

export interface ReviewsTabProps {
    campaign: CampaignQueryDataType;
    reviews: Review[];
}

export const ReviewsTab = ({ campaign, reviews }: ReviewsTabProps) => {
    const [selectedReviewIds, setSelectedReviewIds] = useState<string[]>([]);

    const handleSelect = (review: Review, isSelected: boolean) => {
        if (isSelected) {
            setSelectedReviewIds((prev) => [...prev, review?.id]);
            return;
        }

        setSelectedReviewIds((prev) => prev.filter((id) => id !== review?.id));
    };

    return (
        <>
            {reviews?.map((review, index) => (
                <ReviewCard
                    key={`${index}${review?.id}${review?.state}`}
                    campaign={campaign}
                    review={review}
                    isSelected={selectedReviewIds.indexOf(review?.id) >= 0}
                    onSelect={(isSelected) => handleSelect(review, isSelected)}
                />
            ))}
        </>
    );
};
